var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-0 pa-0", attrs: { width: "100%", outlined: "" } },
    [
      _c(
        "v-card-actions",
        { staticClass: "ma-0 pa-0" },
        [
          _c(
            "v-list",
            [
              _vm._l(_vm.mergeHistory, function (item, index) {
                return [
                  _c(
                    "v-list-item",
                    { key: index },
                    [
                      _c(
                        "v-card",
                        { staticClass: "mv-1", attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                small: "",
                                outlined: "",
                                "text-color": "black",
                              },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm._f("formatDate")(item.date)) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card",
                        { staticClass: "mv-1 ml-2", attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                color: "blue",
                                small: "",
                                "text-color": "white",
                              },
                            },
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "white",
                                    "x-small": "",
                                    "text-color": "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getOwner(
                                          _vm.getDataByName(item.data, "a")
                                            .owner
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "blue",
                                    small: "",
                                    "text-color": "white",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getDataByName(item.data, "a").uid
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-n3",
                                  attrs: { icon: "", color: "white" },
                                  on: {
                                    click: function ($event) {
                                      _vm.editConfig(
                                        _vm.getDataByName(item.data, "a")
                                          .data_path
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "white", size: "15" } },
                                    [_vm._v("mdi-pencil")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-n2",
                                  attrs: { icon: "", color: "white" },
                                  on: {
                                    click: function ($event) {
                                      _vm.exportConfig(
                                        _vm.getDataByName(item.data, "a")
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "white", size: "15" } },
                                    [_vm._v("mdi-content-copy")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-icon", [_vm._v("mdi-plus")]),
                      _c(
                        "v-card",
                        { staticClass: "mv-1", attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                color: "blue",
                                small: "",
                                "text-color": "white",
                              },
                            },
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "white",
                                    "x-small": "",
                                    "text-color": "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getOwner(
                                          _vm.getDataByName(item.data, "b")
                                            .owner
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "blue",
                                    small: "",
                                    "text-color": "white",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getDataByName(item.data, "b").uid
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-n3",
                                  attrs: { icon: "", color: "white" },
                                  on: {
                                    click: function ($event) {
                                      _vm.editConfig(
                                        _vm.getDataByName(item.data, "b")
                                          .data_path
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "white", size: "15" } },
                                    [_vm._v("mdi-pencil")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-n2",
                                  attrs: { icon: "", color: "white" },
                                  on: {
                                    click: function ($event) {
                                      _vm.exportConfig(
                                        _vm.getDataByName(item.data, "b")
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "white", size: "15" } },
                                    [_vm._v("mdi-content-copy")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("v-icon", [_vm._v("mdi-equal")]),
                      _c(
                        "v-card",
                        { staticClass: "mv-1", attrs: { elevation: "0" } },
                        [
                          _c(
                            "v-chip",
                            {
                              attrs: {
                                color: "green",
                                small: "",
                                "text-color": "white",
                              },
                            },
                            [
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "white",
                                    "x-small": "",
                                    "text-color": "black",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getOwner(
                                          _vm.getDataByName(item.data, "c")
                                            .owner
                                        )
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-chip",
                                {
                                  attrs: {
                                    color: "green",
                                    small: "",
                                    "text-color": "white",
                                  },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.getDataByName(item.data, "c").uid
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-n3",
                                  attrs: { icon: "", color: "white" },
                                  on: {
                                    click: function ($event) {
                                      _vm.editConfig(
                                        _vm.getDataByName(item.data, "c")
                                          .data_path
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "white", size: "15" } },
                                    [_vm._v("mdi-pencil")]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-n2",
                                  attrs: { icon: "", color: "white" },
                                  on: {
                                    click: function ($event) {
                                      _vm.exportConfig(
                                        _vm.getDataByName(item.data, "c")
                                      )
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "v-icon",
                                    { attrs: { color: "white", size: "15" } },
                                    [_vm._v("mdi-content-copy")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }